import { render } from "./offline-notice.vue?vue&type=template&id=924e826a"
import script from "./offline-notice.vue?vue&type=script&lang=js"
export * from "./offline-notice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__